import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function LetterSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-20 md:py-32 bg-[#020202] relative" data-id="element-158">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-159">
        <motion.div ref={ref} initial="hidden" animate={isVisible ? 'visible' : 'hidden'} variants={containerVariants} className="glass-card p-8 md:p-12 rounded-3xl" data-id="element-160">
          <motion.div variants={itemVariants} className="flex items-center gap-4 mb-8 md:mb-12 border-b border-white/10 pb-6 md:pb-8" data-id="element-161">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-2xl border-4 border-purple-500/30 shadow-lg" data-id="element-162">
              CC
            </div>
            <div data-id="element-163">
              <p className="font-bold text-lg text-white" data-id="element-164">
                Desde el escritorio de Claudio Conde
              </p>
              <p className="text-gray-400 text-sm" data-id="element-165">
                Re: Tu ROAS depende del creativo
              </p>
            </div>
          </motion.div>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-166">
            <motion.p variants={itemVariants} data-id="element-167">
              Si vendés infoproductos, aceptá la verdad:{' '}
              <span className="text-yellow-400 font-bold bg-yellow-400/10 px-1 rounded" data-id="element-168">
                El targeting ya no importa tanto. El creativo es todo.
              </span>
            </motion.p>

            <motion.p variants={itemVariants} data-id="element-169">Pero hoy estás trabado:</motion.p>

            <motion.ul variants={itemVariants} className="space-y-4 pl-6 border-l-2 border-purple-500/50 my-8" data-id="element-170">
              <li className="flex gap-4" data-id="element-171">
                <span className="text-2xl" data-id="element-172">⏳</span>
                <span data-id="element-173">
                  <strong className="text-white" data-id="element-174">Perdés horas</strong> haciendo
                  prompts en IA para resultados mediocres.
                </span>
              </li>
              <li className="flex gap-4" data-id="element-175">
                <span className="text-2xl" data-id="element-176">🎲</span>
                <span data-id="element-177">
                  <strong className="text-white" data-id="element-178">Testeás poco</strong> (5-10
                  creativos/sem) y rezás que uno funcione.
                </span>
              </li>
              <li className="flex gap-4" data-id="element-179">
                <span className="text-2xl" data-id="element-180">📉</span>
                <span data-id="element-181">
                  <strong className="text-white" data-id="element-182">Tu test no arranca</strong>{' '}
                  real porque nunca tenés volumen suficiente.
                </span>
              </li>
            </motion.ul>

            <motion.h3 variants={itemVariants} className="text-2xl md:text-3xl font-bold text-white pt-4" data-id="element-183">
              Necesitás 100 creativos.
            </motion.h3>

            <motion.p variants={itemVariants} data-id="element-184">
              La matemática es simple:{' '}
              <strong className="text-white" data-id="element-185">
                Solo 2 de cada 100 creativos la rompen.
              </strong>
            </motion.p>

            <motion.p variants={itemVariants} className="font-medium text-white text-xl" data-id="element-186">
              Si testeás 5, es lotería. <br data-id="element-187" />
              <span className="text-purple-400 font-bold" data-id="element-188">
                Si testeás 100, es estadística.
              </span>
            </motion.p>
          </div>

          <motion.div variants={itemVariants} className="pt-10 text-center" data-id="element-189">
            <a href="#pricing" className="inline-block bg-white text-black hover:bg-gray-200 font-bold py-4 px-10 rounded-full transition-all shadow-lg hover:shadow-white/20 transform hover:-translate-y-1" data-id="element-190">
              ACCEDER A LA APP →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}